import React from 'react';
import { motion } from 'framer-motion';
import { OnboardingStep, StepInfo } from '../../../utils/onboardingV2/conversationalOnboardingSteps.ts';
import styles from './OnboardingProgress.module.scss';

interface OnboardingProgressProps {
  steps: StepInfo[];
  activeIndex: number;
  activeLabel?: string;
  editingStep?: OnboardingStep | null;
  onNavigateToStep: (step: OnboardingStep) => void;
}

const OnboardingProgress: React.FC<OnboardingProgressProps> = ({
  steps,
  activeIndex,
  activeLabel,
  editingStep,
  onNavigateToStep,
}) => {
  const totalSteps = steps.length;
  const progressPercent = totalSteps > 1 ? (activeIndex / (totalSteps - 1)) * 100 : 0;

  return (
    <>
      <div className={styles.navigationProgressMeta}>
        <div className={styles.navigationCurrentLabel}>
          {activeLabel}
        </div>
        <div className={styles.navigationProgressLabel}>
          Paso {activeIndex + 1} de {totalSteps}
        </div>
      </div>
      <div
        className={styles.navigationProgressBar}
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={totalSteps}
        aria-valuenow={activeIndex + 1}
        aria-label={`Paso ${activeIndex + 1} de ${totalSteps}`}
      >
        <div className={styles.navigationProgressTrack}>
          <div
            className={styles.navigationProgressFill}
            style={{ width: `${progressPercent}%` }}
          />
          <div className={styles.navigationProgressMarks}>
            {steps.map((step, index) => {
              const isActive = index === activeIndex;
              const isCompleted = index < activeIndex || step.isCompleted;
              const isEditing = editingStep === step.id;
              return (
                <button
                  key={step.id}
                  className={`${styles.navigationProgressMark} ${isCompleted ? styles.navigationProgressMarkActive : ''} ${isActive ? styles.navigationProgressMarkCurrent : ''} ${isEditing ? styles.navigationProgressMarkEditing : ''}`}
                  onClick={() => step.canNavigate && onNavigateToStep(step.id)}
                  disabled={!step.canNavigate}
                  title={step.label}
                  aria-label={step.label}
                  type="button"
                >
                  <span className={styles.navigationProgressMarkInner} />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingProgress;
